export default {
  commonTxt: {
    nodata: "无数据",
    loading: "正在加载中",
    more: "更多"
  },
  main: {
    logo: "临床试验志愿者招募网",
    slide: {
      title: "点击率高的研究",
      detail: "查看详细"
    },
    closing: {
      title: "即将结束募集的公告",
      txt: "天后结束"
    },
    research: {
      tabTitle1: "健康志愿者参与的研究",
      tabTitle2: "患病志愿者参与的研究"
    },
    counter: {
      count1: "今年报名的志愿者人数",
      count2: "今年进行的研究总次数",
      count3: "正在进行中的研究次数",
      persons: "名",
      case: "件"
    },
    banner: {
      txt1: "加为Kakao Talk Plus好友的话,\n可享受1:1的便利快捷的咨询服务。",
      txt2: "Kakao plus朋友 首尔大学临床试验中心",
      txt3: "+ 加为KAKAO TALK PLUS好友的方法"
    }
  },
  login: {
    placeholderId: "输入电子邮件(ID)",
    placeholderPw: "输入密码",
    buttonTxt: "注册",
    user: "님",
    logout: "退出",
    mypage: "我的页面",
    saveId: "存储ID",
    signIn: "会员加入",
    findId: "会员加入",
    findPw: "找回用户名"
  },
  join: {
    title: "会员加入",
    titleStep1: "填写会员信息",
    titleStep2: "填写临床试验志愿书",
    password: "密码",
    confirmPw: "检查口令",
    duplicate: "※已登录的电子邮件(用户名)",
    always: "随时报名",
    alwaysTxt:
      "*申请随时报名的话，各受试者招募人为了确认参与与否情况而可进行联络，请熟知。",
    btnJoin: "加入会员",
    btnCancel: "取消",
    alertCancel: "确定取消会员加入吗?",
    failJoin: "会员加入失败了。",
    completeTit: "会员加入成功了!",
    // completeTxt1, completeTxt2, completeTxt3 삭제
    completeTxt1: "회원님의 이메일(ID)는",
    completeTxt2: "입니다.",
    completeTxt3: "请检查并申请您的志愿项目和适当的招聘。",
    completeBtn: "开始"
  },
  findAccount: {
    titleId: "找回用户名",
    titlePw: "寻找密码",
    titleChangePw: "变更密码",
    mail: "电子邮件",
    placeholderMail: "请输入电子邮件(ID)",
    name: "姓名",
    placeholderName: "请输入您的姓名。",
    gender: "性別",
    rdoMale: "男",
    rdoFemale: "女",
    birth: "出生年月日",
    phone: "手机号码",
    placeholderPh: "请输入手印。",
    newPw: "新口令",
    confirmPw: "检查口令",
    btnTxtId: "找回用户名",
    btnTxtPw: "寻找密码",
    btnTxtLogin: "注册",
    btnTxtHome: "回主页",
    btnTxtChange: "变更密码",
    btnTxtCancel: "取消",
    idResultTitle: "搜索结果",
    idResult: "这是根据相关信息而查询的ID，为了个人信息保护有部分以*为表示",
    errorId: "查询的ID不存在。",
    errorMail: "※电子邮件(用户名)或密码有误",
    withdrawMail: "是已退出的电子邮件(用户名)。",
    alertPw: "变更密码成功了。",
    errorPw: "变更密码失败了。",
    errPwConfirm: "※请设置密码长度为9个字数以上的英文大小写字母+数字+特殊字符组合而成的",
    wrongCnt: "登录被阻止，因为您已超过允许的登录尝试次数。请咨询 Kakao Talk Plus Friend 首尔国立大学医院临床试验中心或 02-741-4221。"
  },
  footer: {
    addr:
      "110-744 韩国首尔市钟路区大学路101番地(连键洞28-21)首尔大学医院医生命研究院临床试验中心",
    familySite: "家庭网站",
    family: [
      { id: 0, href: "https://www.snu.ac.kr/", txt: "首尔大学" },
      { id: 1, href: "http://medicine.snu.ac.kr/", txt: "首尔大学医科学院" },
      // { id: 2, href: "http://clinpharm.snu.ac.kr/", txt: "首尔大学" },
      // {
      //   id: 3,
      //   href: "http://www.snu.ac.kr/index.html",
      //   txt: "首尔大学研究生院合作过程·临床药理学专业页"
      // },
      { id: 2, href: "http://www.snuh.org/intro.do", txt: "首尔大学医院" },
      {
        id: 3,
        href: "http://ctc.snuh.org/",
        txt: "首尔大学医院医学生命研究院"
      },
      {
        id: 4,
        href: "https://hrpp.snuh.org/pub/_/singlecont/view.do",
        txt: "首尔大学医院临床研究伦理中心(HRPP)"
      }
    ]
  },
  navigation: [
    {
      name: "临床试验中心",
      children: [
        "中心介绍",
        "参加临床试验的意义",
        "程序指南",
        "扫描检查及住院通知",
        "首尔大学医院应用软件指南"
      ]
    },
    {
      name: "招募信息",
      children: ["临床试验招聘信息"]
    },
    {
      name: "Contact Us",
      children: ["FAQ", "略图"]
    },
    {
      name: "我的参与信息",
      children: ["会员信息", "临床试验志愿书", "志愿来历", "QnA"]
    }
  ],
  infomation: {
    txt: "临床试验志愿者招募中心 : ",
    contact: "02-741-4221",
    time: " 工作日上午9点~下午6点"
  },
  about: {
    indroduce: {
      title: "首尔大学医院临床试验中心介绍",
      Paragraph1:
        "首尔大学医院临床试验中心设立于1955年，为按照药物临床试验质量管理规范（KGCP）、国际协调会议(ICH）和食品和药物管理局(FDA)的方针等国际规范进行科学、伦理的临床试验提供最佳的研究环境，促进临床试验整体的先进化。2004年被指定为第一家地区临床试验中心。2012年，被指定为韩国第一家临床试验全球卓越中心（GREATS），将实现世界竞争力。",
      Paragraph2:
        "首尔大学医院临床试验中心设有成人、肿瘤、小儿、医疗器械等各领域的空间和设施，并根据各个领域的特性专门运营。为了进行药品（包括新药）及医疗器械的功能及安全性评价、生物等效性研究等，提供基本的研究人员、研究设施及行政人员。不仅首尔大学医院的研究者，具有产学研协同研究相应资格和条件的任何研究者均可使用首尔大学医院临床试验中心。",
      Paragraph3:
        "为了确保研究参与者的权利和安全，首尔大学医院临床试验中心通过了AAHRPP, WHO FERCAP的认证。欢迎各位志愿者积极参与在首尔大学医院临床试验中心进行的具有伦理性、科学性的临床试验。",
      Paragraph4: "详细内容请查看首尔大学医院临床试验中心网站。",
      link: "http://ctc.snuh.org/"
    },
    meaning: {
      title: "参加临床试验的意义",
      Paragraph1:
        "如果可以有助于开发治疗糖尿病、老年痴呆症、过敏性皮炎等疾病更有效的药物，您是否想过其重大意义？首尔大学医院临床试验中心为了治疗多种疾病，在新药临床试验、制药、生物工程领域与积极研发的企业形成合作伙伴关系，实施临床试验。成为首尔大学医院临床试验中心的志愿者，具有以下意义.",
      Paragraph2: "可以在网上申请或电话咨询.",
      list: [
        {
          id: 1,
          txt: "给患有慢性病或重症疾病遭受病痛的患者带来治愈的希望."
        },
        {
          id: 2,
          txt: "为改善社会上对临床试验的偏见贡献力量."
        },
        {
          id: 3,
          txt: "参与试验的过程中可以接受综合性健康体检."
        },
        {
          id: 4,
          txt: "为了感谢志愿者参与临床试验将支付酬金."
        },
        {
          id: 5,
          txt: "有结识新朋友的机."
        },
        {
          id: 6,
          txt: "可以脱离日常生活，休息."
        },
        {
          id: 7,
          txt:
            "有只需一天进行采血的研究，也有需要住院一个月进行的研究，项目种类繁多，因此可根据本人的时间安排参与研究项目.如果有意向成为志愿者，"
        }
      ]
    },
    process: {
      title: "手続き案内",
      processData: [
        {
          id: 1,
          title: "电话筛查",
          imgName: "process_phone",
          cont: `通过网站或电话申请参与临床试验，将与志愿者呼叫中心通话. 志愿者呼叫中心的工作时间为周一~周五上午9点到下午6点. 电话筛查负责人将告知各位是否具备参与研究的基本资格，会向各位询问包括服药药物等各种病历事项. 请您务必诚实回答，这是各位进行安全临床试验的必要条件.`
        },
        {
          id: 2,
          title: "预约筛查",
          imgName: "process_appointment",
          cont:
            "通过电话筛查后将进行筛查预约。筛查之前一般要进行10个小时以上禁食，请携带身份证按照预约时间前来筛查. 如果您未能按时来筛查，可能会丧失日后参加研究的资格，请最少提前一天联系我们取消预约.\n\n 筛查之前要了解的一般事项如下:\n\n- 充分休息和睡眠\n如筛选检查前天没有充分休息，可能落选的机率大或为了复检需要再次随访。"
        },
        {
          id: 3,
          title: "签署同意书",
          imgName: "process_agree",
          cont:
            "在进行预先体检之前，我们将向申请人提供同意书的样本. 同意书中包括对整个研究的详细的信息。该文件包括研究目的、给药剂量、采血次数及量、试验药物相关副作用报道等研究所涉及的全部流程. 通读同意书，了解参与研究的益处及潜在的风险非常重要. 职员将对研究进行说明，对各位的疑惑进行解答. 如果申请人阅读同意书以后，已理解所载内容，将请申请人签字表示同意."
        },
        {
          id: 4,
          title: "筛查过程",
          imgName: "process_screening",
          cont:
            "签署参与研究同意书以后，虽然每项研究存在差异，一般来说都要先在筛查室测身高、体重、生命体征(体温、血压、脉搏)，门诊采血并做心电图检查, 此外还进行小便检查. 检查结束后，再次回到筛查室中，对之后住院或门诊检查相关的事项进行事前说明，然后就可以回家. 筛查过程所需时间根据每项研究有所不同，一般来说包括研究说明及签署同意书大致需要2~3小时."
        },
        {
          id: 5,
          title: "入选志愿者",
          imgName: "process_vounteer",
          cont:
            "结束筛查后，研究人员对筛查后的各种检查结果进行综合分析，电话通知申请者是否可以参与研究."
        },
        {
          id: 6,
          title: "住院",
          imgName: "process_hospital",
          cont:
            "根据不同的研究，住院时间不同，但是一般都在给药前一天晚间8点之前入住医学生命研究院3楼研究病房. 住院病房一般为4-6人间，按性别区分. 到达病房后，将对住院期间的注意事项进行整体说明，到指定的病床上换上病号服。研究病房内的浴室里配有洗发水、香皂、牙膏、沐浴露等，洗衣房里有公用洗衣机，配有洗衣液可以洗衣服. 住院中带来的个人物品，可保管在病房内配有带钥匙的保管箱里. 住院期间不得外出、外宿、见访客、吃零食."
        },
        {
          id: 7,
          title: "第一天",
          imgName: "process_day1",
          cont:
            "虽然每个研究程序不同，但第一天一般是研究过程中实施流程最多的一天. 所有研究流程在规定的时间进行，因此请遵守时间，而且同时为了保证数据的准确，参与的研究人员也将最多. 第一天大致的日程安排为，早上7点50分左右起床，进行小便检查后，从8点开始到午餐前为止，进行采血、生命体征、身体检查、心电图等检查. 一般在8点40分左右给药，第一天早晨一般要禁食，可以在给药4小时以后进食，也可能会有给药2小时以后才可以饮水的限制."
        },
        {
          id: 8,
          title: "给药",
          imgName: "process_medication",
          cont:
            "如上所述，第一天一般会给药. 我们会优先考虑各位志愿者的安全，因此给药日研究人员将常驻病房持续观察. 如果与给药前相比，产生一些轻微的不舒服的症状，可迅速获得研究人员的帮助."
        },
        {
          id: 9,
          title: "饮食",
          imgName: "process_meal",
          cont:
            "除了需要禁食的情况以外，在住院期间向志愿者提供饮食. 根据研究项目的不同，可能对饮食类型有所限制，或者对饮食量有限制，志愿者将无法随意摄取饮食. 此外，根据研究要求，可能只允许在规定的时间摄取食物."
        },
        {
          id: 10,
          title: "活动",
          imgName: "process_acivity",
          cont:
            "首尔大学医院临床试验中心研究病房为了各位的便利，进行了诸多努力. 每张病床上都安装了电视机，可以自由收看自己喜欢的电视节目，休息室还可以玩电子游戏、桌游，可以看漫画等多种书籍，提供舒适温馨的读书环境. 病房内有4台电脑方便志愿者上网. 如果您觉得使用自己的笔记本电脑比使用病房的电脑更方便，也可以携带笔记本电脑."
        },
        {
          id: 11,
          title: "出院",
          imgName: "process_discharged",
          cont:
            "结束所有研究流程后可以出院. 调整出院时间比较困难，虽然各研究项目有所不同，但一般来说，早餐后（一般为10点）办理出院手续."
        },
        {
          id: 12,
          title: "追加来访及电话联络",
          imgName: "process_phone",
          cont:
            "因为复查等原因，可能需要再次访问中心. 这时我们将直接跟各位电话联系，邀请您再次来访."
        },
        {
          id: 13,
          title: "酬金",
          imgName: "process_reward",
          cont:
            "对于你们所花费的时间和努力，我们尽可能提供补偿。你们提供银行存折复印件，一般情况下在研究结束后大约21天内能获得补偿金."
        }
      ]
    },
    subjectguide: {
      title: "扫描检查及住院通知",
      section1: {
        title: "临床实验说明会及访问扫描检查指南",
        subTitle: "临床实验说明会及访问扫描检查指南",
        list: [
          "临床试验的意义",
          "访问前确认事项",
          "访问前注意事项",
          "临床试验说明会及参与扫描检查程序",
          "同意书及制作洗发水时注意事项",
          "参与临床试验时限制事项",
          "检查后进行过程"
        ]
      },
      section2: {
        title: "入院生活指南",
        subTitle: "研究病房入院生活指南",
        list: ["住院生活相关", "研究对象守则"]
      }
    },
    appguide: {
      title: "首尔大学医院应用软件指南",
      title2: "首尔大学医院手机应用程序使用指南",
      cont:
        "서울대학교병원은 스마트폰 상에서 홈페이지를 이용하시는 분들을 위한 서울대학교병원 모바일 애플리케이션을 제작하였습니다.\n 병원 내에서 편리하게 진료를 받는 것은 물론, 병원 밖에서도 쉽게 건강 관리를 할 수 있도록 다양한 기능을 제공합니다.\n 앱에도 진료예약, 예약일정확인, 의료진소개, 병원소식 등을 제공하고 있으며, 구글 플레이 스토어, 애플 앱스토어에서 ‘서울대학교병원’을 검색하여 설치할 수 있습니다.",
      appTxt: "iPhone App",
      androidTxt: "Android App",
      downTxt: "[Download]"
    }
  },
  faq: {
    title: "常见问题",
    list: [
      {
        id: 0,
        tabName: "常见问题",
        cont: [
          {
            id: 0,
            tabName: "申请",
            que: "我是否可以参与?",
            ans: "每个临床试验项目要求的条件都不同。"
          },
          {
            id: 1,
            tabName: "临床试验",
            que: "是否可以查看进行中的临床试验?",
            ans:
              "点击“进行中的研究”查看或向志愿者招募中心电话咨询即可了解详细信息."
          },
          {
            id: 2,
            tabName: "住院",
            que: "亲属和朋友是否可以来访？",
            ans:
              "我们为了保障研究结果的准确性和保护研究参与者的信息，不接受访客。推荐在病房内结识新朋友。"
          },
          {
            id: 3,
            tabName: "申请",
            que: "参与临床试验的风险和益处有哪些？",
            ans:
              "每个研究项目的临床试验潜在的风险和益处不同，在同意参与临床试验之前，会向申请人介绍相关的风险和益处。\n 此外，如果有说明中未涉及的疑问事项，可以向医疗团队提问。 "
          },
          {
            id: 4,
            tabName: "申请",
            que: "谁可以参与研究?",
            ans:
              "本中心实施的临床试验一般情况下年满19岁以上才可以参与。\n 医学上的选定标准每个研究项目都有所不同。1期临床试验根据研究计划书，需要严格具备健康志愿者资格\n 标准的申请人才可以参与。\n 资格标准中可能包括吸烟、医药品、药物使用、酒精等相关内容。2期及3期临床试验，需要具备特定的医学条件，\n 并且和1期具有相似资格标准的申请者可以参与。"
          },
          {
            id: 5,
            tabName: "临床试验",
            que: "什么是临床试验?",
            ans:
              "所谓“临床试验”是为了证明临床试验药品的安全性和有效性，对相应药物的药代动力学、药效学、药理学、\n 临床疗效进行确认，对异常反应进行调查，而以人体为对象实施的试验或研究。\n 临床试验是对尚未得到确认的事项进行研究的学术活动，是研究预防、诊断、治疗疾病方法的重要途径。\n 通过临床试验研发出新的药品、医疗器械、医疗技术，试验成果就可以成为预防、诊断、\n 治疗疾病所使用的标准方法。"
          },
          {
            id: 6,
            tabName: "申请",
            que: "申请参与后是否可以取消?",
            ans:
              "是的，可以取消。临床试验为自愿参与，不仅在做健康体检的阶段，或在参与研究的过程中，都可自由撤销同意，\n 且不会给您带来任何不利影响。\n 但是如果在临床试验的过程中撤销同意，医生可能会请您再次来中心进行检查。"
          },
          {
            id: 7,
            tabName: "临床试验",
            que: "是否能对我的信息保密？",
            ans:
              "首尔大学医院的职员将保护志愿者的个人信息，除法律要求提交的情况以外，不会对外泄露各位的医疗信息。\n 临床试验委托机构及食品药品监督管理局等相关监管机关为了确认医疗记录及参与者身份可能会查看姓名、\n 地址等个人信息，也有可能在检查期间进行复印。在上所述的情况下，无法保障对个人信息进行绝对保密。"
          }
        ]
      },
      {
        id: 1,
        tabName: "临床试验",
        cont: [
          {
            id: 0,
            que: "是否可以查看进行中的临床试验?",
            ans:
              "点击“进行中的研究”查看或向志愿者招募中心电话咨询即可了解详细信息."
          },
          {
            id: 1,
            que: "什么是临床试验?",
            ans:
              "所谓“临床试验”是为了证明临床试验药品的安全性和有效性，对相应药物的药代动力学、药效学、药理学、\n 临床疗效进行确认，对异常反应进行调查，而以人体为对象实施的试验或研究。\n 临床试验是对尚未得到确认的事项进行研究的学术活动，是研究预防、诊断、治疗疾病方法的重要途径。\n 通过临床试验研发出新的药品、医疗器械、医疗技术，试验成果就可以成为预防、诊断、\n 治疗疾病所使用的标准方法。"
          },
          {
            id: 2,
            que: "参与临床试验是否存在风险？",
            ans:
              "每个临床试验项目的临床试验的风险都不同，医学研究伦理审议委员会(IRB)对临床试验的危险程度以及应对风险的\n 方法是否恰当进行审查后，批准实施临床试验。因此，在试验设计的阶段可以把临床试验的危险性控制到最小化。\n 当然，研究人员也将在临床试验实施的过程中，持续进行风险管理。"
          },
          {
            id: 3,
            que: "参与临床试验就要吃研发中的药物吗？",
            ans:
              "临床试验中可能吃研发中的药物，也可能吃已开发的现有的药物，或者安慰剂(伪药)。\n 因此，如果志愿者被安排至服用现有的药物或安慰剂(伪药)的对照组，可能不会服用研发中的药物。"
          },
          {
            id: 4,
            que: "新药如何通过审批？",
            ans:
              "需要通过广泛的试验及严格的审批过程。首先，进入临床试验阶段的药物已经通过了严格的非临床试验过程。\n 经过监管机构批准进行下一阶段的试验后，通过临床试验考察药物对人体的安全性。\n 此后，再经过监管机构批准, 就可以将临床试验药物用在患有特定疾病的患者身上，进行安全性和有效性试验。\n 然后，赞助商(Sponsor)将向监管机构提交有关药物的批准/驳回或者需要进行追加试验的报告书。 "
          },
          {
            id: 5,
            que: "申请参与后是否可以取消?",
            ans:
              "是的，可以取消。临床试验为自愿参与，不仅在做健康体检的阶段，或在参与研究的过程中，都可自由撤销同意，\n 且不会给您带来任何不利影响。\n 但是如果在临床试验的过程中撤销同意，医生可能会请您再次来中心进行检查。"
          },
          {
            id: 6,
            que: "临床试验参与者的权利和福利如何保护？",
            ans:
              "临床试验由具备资质的医疗团队实施。\n 此外，存在关于保护临床试验参与者的规定和临床试验实施方法相关的标准。\n 例如，医学研究伦理审议委员会 (IRB, Institutional Review Board)会对研究计划书和相关资料进行检讨，\n 使试验过程可以科学地在伦理规范的范围内进行。\n IRB将对向临床试验参与者提供关于研究实施的理由、实施过程、相关风险和以往研究结果等信息的\n 提供过程进行监督。"
          },
          {
            id: 7,
            que: "是否能对我的信息保密？",
            ans:
              "首尔大学医院的职员将保护志愿者的个人信息，除法律要求提交的情况以外，不会对外泄露各位的医疗信息。\n 临床试验委托机构及食品药品监督管理局等相关监管机关为了确认医疗记录及参与者身份可能会查看姓名、\n 地址等个人信息，也有可能在检查期间进行复印。在上所述的情况下，无法保障对个人信息进行绝对保密。"
          }
        ]
      },
      {
        id: 2,
        tabName: "临床试验",
        cont: [
          {
            id: 0,
            que: "是否有酬金?",
            ans:
              "是的。对于各位志愿者投入时间和精力参与研究，我们会支付相应的酬金。\n根据研究期间和种类，酬金有所不同，具体内容可在现在“进行中的研究”中进行确认。"
          },
          {
            id: 1,
            que: "如何获得酬金?",
            ans: "研究结束3周以内会存入您的账户。"
          }
        ]
      },
      {
        id: 3,
        tabName: "申请",
        cont: [
          {
            id: 0,
            que: "我是否可以参与?",
            ans: "每个临床试验项目要求的条件都不同。"
          },
          {
            id: 1,
            que: "参与临床试验的风险和益处有哪些？",
            ans:
              "每个研究项目的临床试验潜在的风险和益处不同，在同意参与临床试验之前，会向申请人介绍相关的风险和益处。\n 此外，如果有说明中未涉及的疑问事项，可以向医疗团队提问。"
          },
          {
            id: 2,
            que: "女性也可以参与吗？",
            ans:
              "是的。所有年龄层的男女志愿者都可以参与。事实上，我们也需要包括闭经期女性在内的女性志愿者。"
          },
          {
            id: 3,
            que: "申请参与后是否可以取消?",
            ans:
              "是的，可以取消。临床试验为自愿参与，不仅在做健康体检的阶段，或在参与研究的过程中，都可自由撤销同意，\n 且不会给您带来任何不利影响。\n 但是如果在临床试验的过程中撤销同意，医生可能会请您再次来中心进行检查。"
          },
          {
            id: 4,
            que: "是否可以同时参加多项研究？",
            ans:
              "不可以。志愿者在结束一项临床试验后，需要隔1~3个月才可以参与其它临床试验。"
          },
          {
            id: 5,
            que: "是否可以经常参与临床试验?",
            ans:
              "一项临床试验结束后要经过1~3个月休药期，才可以自由参与其它临床试验。"
          },
          {
            id: 6,
            que: "志愿者的义务有哪些？",
            ans:
              "根据不同的临床试验，为了保障试验结果的准确性，有一些必须遵守的条件。\n 例如，禁止运动、吸烟、吃药及喝酒等。\n 各位参与研究之前，我们将向各位详细说明具体的义务方面的信息。"
          },
          {
            id: 7,
            que: "在哪里可以看到预计实施的临床试验?",
            ans:
              "点击现在进行中的研究，可以看到更多关于研究的信息。\n 包括临床试验的标题、日期、酬金以及招募的志愿者标准相关的详细信息。"
          },
          {
            id: 8,
            que: "谁可以参与研究?",
            ans:
              "本中心实施的临床试验一般情况下年满19岁以上才可以参与。\n 医学上的选定标准每个研究项目都有所不同。1期临床试验根据研究计划书，需要严格具备健康志愿者资格\n 标准的申请人才可以参与。\n 资格标准中可能包括吸烟、医药品、药物使用、酒精等相关内容。2期及3期临床试验，需要具备特定的医学条件，\n 并且和1期具有相似资格标准的申请者可以参与。"
          },
          {
            id: 9,
            que: "研究如何进行？",
            ans:
              "参与1期临床试验，一般在病房至少要住一天或一天以上，也可能会要求多次来门诊检查或在家服用药物。\n 住院期间以及门诊检查的次数根据研究项目而不同。住院期间会进行多次采血、身体检查、生命体征检查等，\n 没有检查的时候可以看书、学习、看电视或玩游戏，也可以上网"
          },
          {
            id: 10,
            que: "服药中是否可以参与?",
            ans:
              "根据所参与临床试验的要求，规定有所不同。每个临床试验项目的要求事项都不同。\n ，在服药期间可能无法参与大部分健康志愿者为对象的临床试验。如果是在短期治疗过程，\n 可以在治疗结束后参与研究。\n 但是针对患者的研究，有可能服药中也可以参与，临床试验的设计可能允许服药。如果您有关于服药的问题，\n 请联系志愿者招募中心。"
          }
        ]
      },
      {
        id: 4,
        tabName: "预先体检 (筛选检查)",
        cont: [
          {
            id: 0,
            que: "预先体检要做些什么?",
            ans:
              "确认身份证。\n 医疗团队对研究进行说明，接受提问。\n 如果各位同意参与研究，就在同意书上签字。\n 收集详细的医学方面、社会上的信息\n 采集血液、尿液样本。\n 测量血压、脉搏、心电图。\n 检查结果出来以后，我们会与申请人联系，告知下一阶段的具体事宜。"
          },
          {
            id: 1,
            que: "预先体检需要多长时间?",
            ans:
              "根据不同的研究项目，检查所需的时间有所不同。平均需要2~3个小时。"
          },
          {
            id: 2,
            que: "为什么参与研究前，每次都要进行预先体检?",
            ans:
              "预先体检是对参与临床试验的人员进行筛选的过程。因为临床试验以相对较少的人员为对象实施，\n 所以必须由可以提供准确数据，符合研究标准的志愿者才可以参与。医生们通过参考检查结果，\n 对每个研究项目的申请人进行筛选。"
          },
          {
            id: 3,
            que: "如果在预先体检中落选会如何？",
            ans:
              "在预先体检中落选有很多理由，如果您想知道落选原因，我们都会一一解释，这一点不用担心。\n 并且您也可以向志愿者招募中心咨询是否可以参与日后或现在进行中的其它研究项目。"
          }
        ]
      },
      {
        id: 5,
        tabName: "住院",
        cont: [
          {
            id: 0,
            que: "必须要住院吗?",
            ans:
              "根据参与的研究项目而有所不同。有的研究只需1次门诊检查和住院1晚。但是一般情况下，\n 为了对临床试验结果进行监督，所以需要住院更久。在病房中可以自由活动。"
          },
          {
            id: 1,
            que: "住院时要带些什么东西？",
            ans:
              "卫生间里配备了香皂、洗发水、牙膏、吹风机，还提供病员服、毯子、毛巾、拖鞋、一次性剃须刀、水杯、牙刷\n （需住院2次以上时，只有第一次住院时会提供）。根据您的需要，您可以带来护肤品、沐浴用品、内衣、书籍、\n 笔记本电脑等。本中心对个人物品丢失、被盗不承担责任。"
          },
          {
            id: 2,
            que: "是否可以使用手机或笔记本电脑?",
            ans: "是的。住院时可以带来。"
          },
          {
            id: 3,
            que: "是否可以外出?",
            ans:
              "一般来说，住院期间不能离开临床试验中心研究病房，如果是长期住院，在医疗团队同意的情况下可以外出。"
          },
          {
            id: 4,
            que: "必须要在规定的日期参加吗？",
            ans:
              "是的。每项临床试验的参与日期都是规定好的，必须要在规定的日期参加。\n 临床试验的研究设计多种多样，我们在规定的时间做相应的各项检查，对观察药物的作用机制非常重要。\n 因此，各位必须严格遵守本中心规定的日期和时间按时来访。\n 但是，除住院时间以外的门诊来访时间，有可能可以根据研究项目而进行调整，\n 所以请向志愿者招募中心咨询。"
          },
          {
            id: 5,
            que: "亲属和朋友是否可以来访？",
            ans:
              "我们为了保障研究结果的准确性和保护研究参与者的信息，不接受访客。推荐在病房内结识新朋友。"
          }
        ]
      }
    ]
  },
  recruit: {
    all: "全部的",
    male: "男",
    female: "女",
    koreanAge: "만",
    month: "个月",
    currency: "韩元",
    age: "岁"
  },
  recruitList: {
    title: "临床试验招聘信息",
    alertAge: "请输入您的年龄。",
    alertEnt: "请输入可参与期间。",
    alertHeight: "请输入您的身高。",
    alertWeight: "请输入您的体重。",
    pagingResult: " 项搜索结果",
    buttonReset: "初始化",
    buttonSubmit: "搜索",
    buttonTxt: "只搜索可参与的研究",
    search: {
      disease: "疾病分类",
      gender: "性別",
      age: "年龄",
      smoking: "是否吸烟",
      term: "参与期限",
      height: "身高",
      weight: "体重",
      history: "病历",
      select: "选择一个"
    },
    searchRdo: {
      all: "全部",
      male: "男",
      female: "女",
      smoking: "吸烟",
      nonSmoking: "非吸烟",
      input: "输入",
      none: "不符合",
      yes: "选择一个"
    },
    loding: "正在加载中",
    noResult: "无结果"
  },
  recruitView: {
    viewTitle: "临床试验详细内容",
    buttonMember: "会员申请",
    buttonNonMember: "非会员申请",
    cancerTxt: "※ 肿瘤研究只能打电话志愿。 联系电话 : ",
    closedTxt: "已结束的招募公告。",
    title: {
      apply: "志愿方法",
      gender: "性別",
      age: "年龄",
      classify: "研究分类",
      type: "临床试验种类",
      term: "参与期限",
      sector: "志愿类型",
      smoker: "吸烟者",
      smokerY: "吸烟者可参与",
      smokerN: "吸烟者不得参与",
      cancer: "癌症种类",
      disease: "对象疾病",
      history: "病历",
      participation: "参与期限",
      reward: "补偿金",
      recruitPeriod: "招募期间",
      researchPeriod: "研究期间",
      professor: "任课教授",
      stage: "阶段",
      medicine: "临床试验用药品",
      patient: "对象患者",
      info: "附加信息",
      details: "详细内容",
      files: "附件"
    }
  },
  recruitWrite: {
    cancelTxt: "不是",
    nextTxt: "下一步",
    submitTxt: "申请",
    cancelMsg: "确定取消招聘申请吗?",
    submitMsg: "确定申请相应招聘吗?",
    successMsg:
      "志愿者申请已完成。\n 不符合相应招生条件时 \n 可能会被淘汰,请谅解。",
    alreadyMsg: "已申请的招聘公告。",
    recruitTitle: {
      name: "姓名",
      mail: "电子邮件(ID)",
      phone: "手机号码",
      contact: "其他联络电话",
      birth: "出生年月日",
      gender: "性別",
      genderMale: "男",
      genderFemale: "女",
      addr: "地址",
      joinPath: "加入路径",
      preferrede: "喜欢的联络方式",
      rank1: "第一位",
      rank2: "第二位",
      rank3: "第三位",
      rank4: "第四顺位",
      rank5: "第五顺位",
      nation: "民族",
      sector: "志愿者类型",
      height: "身高",
      weight: "体重",
      smoking: "是否吸烟",
      history: "病例",
      type: "临床试验种类",
      disease: "疾病分类",
      term: "研究参与时间常时期间",
      bloodDonation: "献血 ",
      donationDay: "最近献血日",
      donationType: "最近献血类型",
      donationType1: "成分",
      donationType2: "全血",
      bloodTransfusion: "输血",
      transfusionDay: "最后输血日",
      joined: "参与临床试验/\n生物学的同等性试验(生同性试验)经验最后下药日",
      joinedDay: "最后下药日",
      joined3month:
        "是否在6个月以内参加过临床试验\n是否参加过'生物学的同等性试验(生同性试验)",
      joined3Day: "最近参加日",
      drug: "使用药物与否",
      drugName: "药名",
      drugDay: "最后下药日",
      drugTxt:
        "例子)30天内使用的专业医药品(例:医院开出的处方药,需要治疗的特定疾病,长期服用医药品等), 一般药品(例如:消化剂,感冒药,人工泪液,眼药水,药膏,膏药等)均记载",
      allergy: "过敏反应 药物过敏反应",
      allergyType: "种类",
      allergyDay: "最初发生日期",
      allergyTxt:
        "例子)遗传过敏性皮炎,鼻炎,食物过敏,哮喘,抗生素/阿斯匹林/消炎镇痛剂过敏反应等",
      operation: "是否有手术/手术计划",
      operationType: "手术/手术名",
      operationTxt: "例子)临床试验期间内预定的手术或实施手术/拔牙等",
      surgery: "病历/手术历",
      surgeryType: "病名/手术名",
      surgeryTxt:
        "例子)手术/住院治疗,需要治疗的特定疾病,皮肤疾病(干腺,接触性皮炎)或皮内注射时可能会妨碍治疗 疤痕与皮肤异常或手术的过去力等",
      smokingYn: "是否吸烟",
      smokingType: "根/日",
      smokingDay: "最后吸烟日",
      smokingTxt: "(请记录准确的个数)",
      nonSmoking: "非吸烟者",
      smoked: "过去吸烟者",
      smoker: "现在吸烟者",
      step3Type: "种类",
      step3Time: "次数/周,",
      step3Day: "最后摄取日",
      alcohol: "是否喝酒",
      alcoholTime: "杯/周,",
      alcoholDay: "最后喝酒日",
      alcoholTxt: "例子)啤酒,烧酒,洋酒等",
      caffeine: "是否摄取含有咖啡因的食品",
      caffeineTxt:
        "含有咖啡的食品,含有巧克力的食品,茶(例子:绿茶,红茶等)种类,碳酸饮料(例子:可乐等),滋养强壮剂(例子:高咖啡因饮料等)",
      etcMedicine: "是否服用中药/健康功能食品",
      etcMedicineTxt:
        "例子)30天内摄取的中药(例:红参等)或健康功能食品(例:欧米茄-3脂肪酸,维生素D,钙,综合维生素等)全部记载。",
      diet: "预计影响临床试验的非正常饮食摄取与否",
      dietTxt: "例子)以蛋白质,脂肪质为主,只吃素食,摄取葡萄柚汁等",
      exercise: "运动与否",
      exerciseDay: "最近的运动日",
      meal: "是否可以标准饮食",
      mealTxt: "*标准饮食:医院提供的饮食",
      contraception: "临床试验期间能否避孕",
      precautions: "是否遵守注意事项",
      precautionsTxt:
        "* 注意事项:根据研究项目不同可发生差异,在整个临床试验期间内严格限制攝取其他药品、中药、健康功能食品,禁止饮酒、吸烟、献血及输血。 使用临床试验用药品一周前,禁止饮酒、含有咖啡因和葡萄糖的食品。 筛选访问时,至少持续8小时以上空腹状态,多喝水,带本人身份证。",
      caution:
        "如果您提交的志愿书适合研究,将会以电话方式通知您详细日程。\n 即使是您填写志愿书后访问医院,不符合研究要求的话,则不能参加研究,请回家。\n 电话咨询内容不代表实际参加研究,通过自行访问医院与医疗团队进行商谈方式才能决定是否可参与研究。所有志愿者在通过检查后也有可能无法成为受试者或不能参与研究。对于不通过检查的访问者一律不支付额外的交通费和酬劳。 \n 您同意以上内容并愿意参与申请吗?"
    }
  },
  agree: {
    title: "首尔大学医院临床试验中心",
    agreeTitle: "同意个人信息收集及使用",
    agreeY: "同意",
    agreeN: "不同意",
    btnCancel: "不是",
    btnSubmit: "下一步",
    agreeMsg: "请同意个人信息管理方针指南。",
    desc: [
      {
        title: "1. 人信息的收集及使用",
        cont:
          "首尔大学医院临床试验中心根据《促进信息通信网使用及信息保护法》及《个人信息保护法》，征得志愿者对个人信息收集ㆍ使用的同意。"
      },
      {
        title: "① 个人信息收集ㆍ使用的目的",
        cont: [
          "ㆍ临床试验志愿者备案",
          "ㆍ提供在医院进行的各种活动信息、诊疗信息及临床研究信息"
        ]
      },
      {
        title: "② 个人信息的保留ㆍ使用期限",
        cont: "您的个人信息将保留到达成信息收集・使用的目的为止。"
      },
      {
        title: "③ 收集的个人信息项目",
        cont: [
          "ㆍ姓名、出生日期、性别、民族、申请途径、电子邮箱、messenger ID、电话号码、地址、喜欢的联系方式、落选原因等参与研究所需的信息",
          "ㆍ以上述同一目的收集的您的敏感信息如下。",
          "- 身体信息(身高, 体重)",
          "- 过往诊疗记录等病史",
          "ㆍ除此以外通过网站申请参与临床试验时，在申请栏填写的项目"
        ]
      },
      {
        title: "④ 拒绝个人信息收集ㆍ使用的权利",
        cont:
          "试验当事人或试验当事人的代理人有权利拒绝个人信息的收集。但是，如果拒绝收集，将无法参与临床试验。"
      },
      {
        title: "2. 个人信息的处理及保留期限",
        cont:
          "首尔大学医院临床试验中心在法律规定的个人信息保留 • 使用期限或从信息主体处获取个人信息时获得同意的个人信息保留 • 使用期限内对个人信息进行处理 • 保留。"
      }
    ]
  },
  contact: {
    title: "略图",
    subTitle: "临床试验自愿者报名咨询",
    contactData: [
      {
        id: 0,
        title: "地址",
        cont:
          "10-744 首尔市 钟路区 大学路 101（莲建洞28）首尔大学医院 医生命研究院 4楼"
      },
      {
        id: 1,
        title: "电话号码",
        cont: "02-741-4221 (工作日上午9点~下午6点)"
      },
      { id: 2, title: "电子邮件", cont: "info@snuh.co.kr" }
    ],
    data: [
      {
        id: 0,
        traffic: "使用公交时",
        description: [
          {
            id: 0,
            station: "昌庆宫 首尔大学医院 下行 [01002]",
            way:
              "蓝色(干线公交) : 102, 104, 106, 107, 108, 140, 143, 149, 150, 151, 160, 162, 171, 172, 272, 301, 710"
          },
          {
            id: 1,
            station: "昌庆宫入口 上行 [01224]",
            way: "蓝色(干线公交) : 151, 171, 172, 272, 601"
          },
          {
            id: 2,
            station: "	惠化站 首尔大学医院入口 3号出口前 下行 [01221]",
            way:
              "蓝色(干线公交) : 102, 104, 106, 107, 108, 109, 143, 149, 150, 160, 162, 273, 301, 601, 710\n绿色(支线公交) : 2112, 钟路08"
          },
          {
            id: 3,
            station: "惠化站 马罗尼埃公园前 上行",
            way:
              "蓝色(干线公交) : 102, 104, 106, 107, 108, 109, 143, 149, 150, 160, 162, 273, 301, 710\n绿色(支线公交): 2112, 钟路08, 钟路12(医院循环大巴)"
          }
        ]
      },
      {
        id: 1,
        traffic: "使用火车、机场时",
        description: [
          {
            id: 0,
            station: "首尔站",
            way: "首尔站 地铁4号线 → 惠化站3号出口"
          },
          {
            id: 1,
            station: "龙山站",
            way: "龙山站 地铁4号线 → 惠化站3号出口"
          },
          {
            id: 2,
            station: "金浦机场",
            way: "金浦机场站 机场铁道->首尔站（换乘4号线）->惠化站3号出口"
          },
          {
            id: 3,
            station: "仁川机场",
            way: "仁川国际机场站 机场铁道->首尔站（换乘4号线）->惠化站3号出口"
          }
        ]
      },
      {
        id: 2,
        traffic: "乘坐高速/市外巴士时",
        description: [
          {
            id: 0,
            station: "江南高速巴士客运站",
            way:
              "地铁3号线 高速巴士客运站 → 钟武璐站(换乘四号线) → 惠化站3号出口"
          },
          {
            id: 1,
            station: "南部高速巴士客运站",
            way:
              "地铁3号线 南部高速巴士客运站 → 钟武璐站(换乘四号线) → 惠化站3号出口"
          },
          {
            id: 2,
            station: "东首尔高速巴士客运站",
            way:
              "江边站 地铁 2号线->东大门历史文化公园站(换乘4号线) ->惠化站3号出口"
          },
          {
            id: 3,
            station: "上凤高速巴士客运站",
            way:
              "	地铁7号线 上凤站 → 君子站(换乘5号线) → 东大门历史文化公园站(换乘4号线) → 惠化站3号出口"
          }
        ]
      }
    ],
    other: {
      traffic: "使用高速公路(驾车)时",
      way:
        "京部线首尔收费站 → 韩南大桥 → 乙支路 → 梨花交叉路 → 大学路 → 首尔大学医院",
      txt:
        "参与筛选检查者可免费停车4小时。因病历或BMI不能参与筛选检查时自付停车费。"
    }
  },
  userInfo: {
    infoTitle: "会员信息",
    modifyTitle: "修改会员信息",
    applyTitle: "临床试验志愿书",
    applyModifyTitle: "修改临床试验志愿书",
    joinDate: "加入日期",
    changePw: "变更密码",
    male: "男",
    female: "女",
    participation: "参与期限",
    alwaysTit: "常时",
    btnModify: "修订",
    btnWithdraw: "退出",
    btnSave: "存储",
    btnCancel: "取消",
    failMsg: "储存失败了。"
  },
  withdrawal: {
    title: "退出会员",
    section1: {
      tit: "退出程序",
      cont: "会员退出之前一定要确认注意事项。"
    },
    section2: {
      tit: "电子邮件(用户名)无法重新使用或恢复的说明",
      cont:
        "如果您退出正在使用的电子邮件(用户名)话，不可能重新使用或恢复。请慎重选择。"
    },
    section3: {
      tit: "会员信息及个人服务使用记录的删除说明",
      cont:
        "不但会员信息，临床试验志愿书，志愿来历和服务使用记录在我的咨询现状都将被删除，而且已被删除的数据无法恢复。"
    },
    step2: {
      tit: "为了安全的退出会员，请确认密码。",
      cont:
        "先确认密码后电子邮件(用户名)就会立即被退出。\n\n如果您退出正在使用的电子邮件(用户名)话，不可能重新使用或恢复。请慎重选择。"
    },
    form: {
      txt1: "电子邮件(ID)",
      txt2: "密码"
    },
    btnCancel: "取消退出",
    btnStepNext: "下一步",
    btnWithdraw: "退出"
  },
  recruitHistory: {
    title: "志愿来历"
  }
};
